export const SURVEY_YES_NO = "survey_yes_no"
export const SURVEY_PRONOSTIC = "survey_pronostic"

export const NOTATION_PLAYER = "notation_player"
export const NOTATION_MATCH = "notation_match"